import { createActions, handleActions } from 'redux-actions'

const defaultState = {
  isRouting: true,
  questId: '',
  // Filter-related state
  selectedProgressOverviewShowAllContent:   false,
  selectedProgressOverviewModuleIds:        [],
  selectedProgressOverviewContentTypes:     [],
  committedProgressOverviewShowAllContent:  false,
  committedProgressOverviewModuleIds:       [],
  committedProgressOverviewContentTypes:    [],
  ngssDimensionsShowAllContent:             false,
  ngssDimensionsContentType:                1, // 1 = All Types, 2 = CCCs, 3 = DCIs, 4 = SEPs
  performanceExpectationsShowAllContent:    false,
  performanceExpectationsModuleIds:         [],
  expeditionAssignments:                    []
}

// Action definitions
const {
  setRoutingStatus,
  setQuestId,
  selectProgressOverviewShowAllContent,
  selectProgressOverviewModuleIds,
  selectProgressOverviewContentTypes,
  commitSelectedProgressOverviewFilters,
  revertSelectedProgressOverviewFilters,
  selectNgssDimensionsShowAllContent,
  selectNgssDimensionsContentType,
  selectPerformanceExpectationsShowAllContent,
  selectPerformanceExpectationsModuleIds,
  setExpeditionAssignments
} = createActions({
  SET_ROUTING_STATUS:                               isRouting => ({ isRouting }),
  SET_QUEST_ID:                                     questId => ({ questId }),
  SELECT_PROGRESS_OVERVIEW_SHOW_ALL_CONTENT:        val => ({ val }),
  SELECT_PROGRESS_OVERVIEW_MODULE_IDS:              ids => ({ ids }),
  SELECT_PROGRESS_OVERVIEW_CONTENT_TYPES:           types => ({ types }),
  COMMIT_SELECTED_PROGRESS_OVERVIEW_FILTERS:        undefined,
  REVERT_SELECTED_PROGRESS_OVERVIEW_FILTERS:        undefined,
  SELECT_NGSS_DIMENSIONS_SHOW_ALL_CONTENT:          val => ({ val }),
  SELECT_NGSS_DIMENSIONS_CONTENT_TYPE:              val => ({ val }),
  SELECT_PERFORMANCE_EXPECTATIONS_SHOW_ALL_CONTENT: val => ({ val }),
  SELECT_PERFORMANCE_EXPECTATIONS_MODULE_IDS:       ids => ({ ids }),
  SET_EXPEDITION_ASSIGNMENTS:                       assignments => ({assignments})                             
})

// Reducer definition
const reducer = handleActions(
  {
    [setRoutingStatus]:                       (state, { payload: { isRouting }}) => ({ ...state, isRouting }),
    [setQuestId]:                             (state, { payload: { questId }}) => ({ ...state, questId }),
    [selectProgressOverviewShowAllContent]:   (state, { payload: { val }}) => ({ ...state, selectedProgressOverviewShowAllContent: val }),
    [selectProgressOverviewModuleIds]:        (state, { payload: { ids }}) => ({ ...state, selectedProgressOverviewModuleIds: ids }),
    [selectProgressOverviewContentTypes]:     (state, { payload: { types }}) => ({ ...state, selectedProgressOverviewContentTypes: types }),
    [commitSelectedProgressOverviewFilters]:  (state) => ({
        ...state,
        committedProgressOverviewShowAllContent:  state.selectedProgressOverviewShowAllContent,
        committedProgressOverviewModuleIds:       state.selectedProgressOverviewModuleIds,
        committedProgressOverviewContentTypes:    state.selectedProgressOverviewContentTypes,
      }),
    [revertSelectedProgressOverviewFilters]:  (state) => ({
        ...state,
        selectedProgressOverviewShowAllContent:  state.committedProgressOverviewShowAllContent,
        selectedProgressOverviewModuleIds:       state.committedProgressOverviewModuleIds,
        selectedProgressOverviewContentTypes:    state.committedProgressOverviewContentTypes,
      }),
    [selectNgssDimensionsShowAllContent]:           (state, { payload: { val }}) => ({ ...state, ngssDimensionsShowAllContent: val }),
    [selectNgssDimensionsContentType]:              (state, { payload: { val }}) => ({ ...state, ngssDimensionsContentType: val }),
    [selectPerformanceExpectationsShowAllContent]:  (state, { payload: { val }}) => ({ ...state, performanceExpectationsShowAllContent: val }),
    [selectPerformanceExpectationsModuleIds]:       (state, { payload: { ids }}) => ({ ...state, performanceExpectationsModuleIds: ids }),
    [setExpeditionAssignments]:               (state, {payload: {assignments}})=>({...state, expeditionAssignments:assignments || []})
  },
  defaultState
)

export {
  setQuestId,
  setRoutingStatus,
  selectProgressOverviewShowAllContent,
  selectProgressOverviewModuleIds,
  selectProgressOverviewContentTypes,
  commitSelectedProgressOverviewFilters,
  revertSelectedProgressOverviewFilters,
  selectNgssDimensionsShowAllContent,
  selectNgssDimensionsContentType,
  selectPerformanceExpectationsShowAllContent,
  selectPerformanceExpectationsModuleIds,
  setExpeditionAssignments,
  defaultState
}
export default reducer
